import React from "react";
import { Container, Typography, Grid, Paper, Box, styled } from "@mui/material";
import { Location1, Location2, Location3 } from "./Location1";
import "animate.css";

// Styled components
const SectionContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(8, 0),
  backgroundColor: "#0d0d0d",
  color: "#fff",
}));

const MapPaper = styled(Paper)(({ theme }) => ({
  height: "350px",
  width: "320px",
  borderRadius: "16px",
  overflow: "hidden",
  background: "rgba(255, 255, 255, 0.05)",
  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.5)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  backdropFilter: "blur(8px)",
  transition: "transform 0.4s ease, box-shadow 0.4s ease",
  "&:hover": {
    transform: "scale(1.03)",
    boxShadow: "0 12px 35px rgba(255, 255, 255, 0.2)",
  },
}));

const LocationBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#1a1a1a",
  borderRadius: "12px",
  padding: theme.spacing(3),
  textAlign: "center",
  height: "100%",
  color: "#fff",
  boxShadow: "0 6px 20px rgba(255,255,255,0.05)",
  transition: "all 0.4s ease",
  "&:hover": {
    backgroundColor: "#222",
  },
}));

const AddressText = styled(Typography)(({ theme }) => ({
  color: "#ffea00",
  fontWeight: "500",
  marginBottom: theme.spacing(1),
}));

// Location data
const locations = [
  //{
  //   id: 1,
  //   name: "12990 National Rd SW, Etna, OH",
  //   frame: Location1,
  //   address: "CALL: +1 (740) 919-0006",
  // },

  // {
  //   id: 2,
  //   name: "8515 Refugee Rd, Pickerington, OH",
  //   frame: Location2,
  //   address: "CALL: +1 (614) 321-4059",
  // },

  {
    id: 3,
    name: "859 Windmiller Dr, Pickerington, OH",
    frame: Location3,
    address: "CALL: +1 (281) 948-8761 / +1 (614) 490-7698",
  },
];

const Locations = () => {
  return (
    <SectionContainer>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          className="animate__animated animate__fadeInDown"
          sx={{ fontWeight: 600, color: "#ffea00", marginBottom: 6 }}
        >
          Our Salon Locations
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {locations.map((location, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={2}
              key={location.id}
              className="animate__animated animate__fadeInUp"
              style={{
                animationDelay: `${idx * 0.15}s`,
                animationDuration: "1s",
              }}
            >
              <LocationBox>
                <Typography variant="h6" gutterBottom>
                  {location.name}
                </Typography>
                <AddressText variant="body1">{location.address}</AddressText>
                <MapPaper>
                  <location.frame />
                </MapPaper>
              </LocationBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </SectionContainer>
  );
};

export default Locations;
